import {
  PERMISSION_CONFIG_TOUR,
  PERMISSION_CREATE_PUBLIC_ICON_TEMPLATE,
  PERMISSION_CREATE_SALE_CONTACT,
  PERMISSION_CREATE_SCENE,
  PERMISSION_CREATE_TOUR,
  PERMISSION_CREATE_TOUR_GUIDE,
  PERMISSION_VIEW_ALL_SCENES,
  PERMISSION_VIEW_ALL_TOURS,
  PERMISSION_VIEW_ITEM_INFOS,
  PERMISSION_VIEW_PROMOTIONS,
  PERMISSION_VIEW_SALE_CONTACTS,
  PERMISSION_VIEW_SCENES,
  PERMISSION_VIEW_TOUR_GUIDES,
  PERMISSION_VIEW_TOURS,
  PERMISSION_VIEW_USER_CONTACTS,
  PERMISSION_VIEW_WEB_ROTATE,
  PERMISSION_CONFIG_POI_TEMPLATE,
} from '../../commons/constants/permissions';
import { THEME_LINK } from '../../commons/constants/links';

export default [
  {
    title: 'Dashboard',
    key: 'dashboard',
    url: '/dashboard',
    icon: <i className="fas fa-tachometer-alt"></i>,
  },
  {
    title: 'Admin',
    key: 'admin',
    icon: <i className="fas fa-table"></i>,
    permissions: [PERMISSION_VIEW_ALL_TOURS, PERMISSION_VIEW_ALL_SCENES],
    children: [
      {
        key: 'admin-scene',
        title: 'Scenes',
        url: '/admin/scenes',
        icon: <i className="fas fa-layer-group"></i>,
        permissions: [PERMISSION_VIEW_ALL_SCENES],
      },
      {
        key: 'admin-tour',
        title: 'Tours',
        url: '/admin/tours',
        icon: <i className="fas fa-map-signs"></i>,
        permissions: [PERMISSION_VIEW_ALL_TOURS],
      },
    ],
  },
  {
    title: 'Manage',
    key: 'manage',
    icon: <i className="fas fa-pencil-ruler"></i>,
    children: [
      {
        key: 'contacts',
        title: 'User Contacts',
        url: '/user-contacts',
        icon: <i className="fas fa-address-book"></i>,
        permissions: [
          PERMISSION_VIEW_SALE_CONTACTS,
          PERMISSION_VIEW_USER_CONTACTS,
          PERMISSION_CREATE_SALE_CONTACT,
          PERMISSION_VIEW_USER_CONTACTS,
        ],
      },
      {
        key: 'scene',
        title: 'Scenes',
        url: '/scenes',
        icon: <i className="fas fa-layer-group"></i>,
        permissions: [PERMISSION_VIEW_SCENES, PERMISSION_CREATE_SCENE],
      },
      {
        key: 'tour',
        title: 'Tours',
        url: '/tours',
        icon: <i className="fas fa-map-signs"></i>,
        permissions: [PERMISSION_CREATE_TOUR, PERMISSION_VIEW_TOURS],
      },
      {
        key: 'draft-tour',
        title: 'Draft Tours',
        url: '/draft-tours',
        icon: <i className="fas fa-map-signs"></i>,
        permissions: [PERMISSION_CREATE_TOUR, PERMISSION_VIEW_TOURS],
      },
      {
        key: 'tour-edit',
        title: 'Edit Tour',
        regex: /^\/tour\//,
        hidden: true,
        permissions: [PERMISSION_CONFIG_TOUR],
      },
      {
        key: 'web-rotate',
        title: 'Web Rotate',
        url: '/admin/web-rotate',
        icon: <i className="fas fa-cube" />,
        permissions: [PERMISSION_VIEW_WEB_ROTATE],
      },
      {
        key: 'item-infos',
        title: 'Item Info',
        url: '/item-infos',
        icon: <i className="fas fa-book" />,
        permissions: [PERMISSION_VIEW_ITEM_INFOS],
      },
      {
        key: 'promotions',
        title: 'Promotions',
        url: '/promotions',
        icon: <i className="fas fa-tag" />,
        permissions: [PERMISSION_VIEW_PROMOTIONS],
      },
      {
        key: 'poi-template',
        title: 'Poi Template',
        url: '/poi-template',
        icon: <i className="fas fa-window-restore" />,
        permissions: [PERMISSION_CONFIG_POI_TEMPLATE],
      },
    ],
  },
  {
    title: 'Media',
    key: 'media',
    icon: <i className="fas fa-cloud-upload-alt"></i>,
    children: [
      {
        key: 'tourguide',
        title: 'Tour Guides',
        url: '/tour-guides',
        icon: <i className="fas fa-headset"></i>,
        permissions: [PERMISSION_VIEW_TOUR_GUIDES, PERMISSION_CREATE_TOUR_GUIDE],
      },
      {
        key: 'iconLibrary',
        title: 'Icon Library',
        url: '/icon-library',
        icon: <i className="fas fa-icons"></i>,
        permissions: [PERMISSION_CONFIG_TOUR],
      },
      {
        key: 'themes',
        title: 'Themes',
        url: THEME_LINK,
        icon: <i className="fas fa-brush"></i>,
        permissions: [PERMISSION_CREATE_PUBLIC_ICON_TEMPLATE],
      },
    ],
  },
  {
    key: 'account',
    title: 'Account',
    regex: /^\/account/,
    hidden: true,
  },
];
